module.exports = __webpack_public_path__ + "static/img/15.f1e3cfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/15.png
// module id = jUcT
// module chunks = 1